import { render, staticRenderFns } from "./Determination.vue?vue&type=template&id=4439ff52&scoped=true"
import script from "./Determination.vue?vue&type=script&lang=js"
export * from "./Determination.vue?vue&type=script&lang=js"
import style0 from "./Determination.vue?vue&type=style&index=0&id=4439ff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439ff52",
  null
  
)

export default component.exports